import { FC, createContext, Dispatch, ReactNode, SetStateAction, useContext } from "react";
import { RCItemType } from "src/types/RCItemType";

type TopupContextType = {
    item?:RCItemType;
    isFetching:boolean;

}

const TopupDetailsContext = createContext<TopupContextType|null>(null);


export const TopupDetailsProvider: FC<{value:TopupContextType , children:ReactNode}> = ({value, children})=>{
    return <TopupDetailsContext.Provider value={value}>
        {children}
    </TopupDetailsContext.Provider>
}

export const useTopupDetails = ()=>{
    const context = useContext(TopupDetailsContext);
    if (!context) throw new Error("Illegal Usage Of useTopupDetails outside TopupDetailsContext");
    return context;
}
